var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{ref:"video_r",attrs:{"type":"file","id":"file","accept":"video/*"},on:{"change":_vm.upload_video}}),_c('progress',{attrs:{"id":"file","max":"100"},domProps:{"value":_vm.vlp}},[_vm._v(" "+_vm._s(_vm.vlp)+"}% ")])])}
var staticRenderFns = []

export { render, staticRenderFns }